var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"page-bg"}),_c('mu-list',{staticClass:"list animated slideInUp"},_vm._l((_vm.data.chapter_lists),function(item){return _c('mu-list-item',{key:item.id,staticClass:"item",attrs:{"ripple":false,"to":{
        path: _vm.getPath,
        query: {
          chapter_id: item.id,
          is_visible: _vm.$route.query.is_visible,
          allow_practise: _vm.$route.query.allow_practise,
        },
      },"button":""}},[_c('mu-list-item-title',[_vm._v("\n        "+_vm._s(item.title)+"\n      ")]),_c('mu-list-item-action',[_c('mu-icon',{attrs:{"value":"chevron_right"}})],1)],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }